// @flow
import React from 'react'
import styled from 'styled-components'
import { mediaMax, mediaMin } from 'components/styles/_media'
import TopicItemCard, {
  type PropTypes as TopicItemCardTypes,
} from 'components/molecules/TopicListItem'
import Colors from 'components/styles/colors'
import type { Topic } from 'types/www/topic'
import OptimizedImage from 'components/atoms/OptimizedImage'
import { imageURLWithTransform } from 'frontend_core/dist/helpers/format'

type PropTypes = {
  title: string,
  content: string,
  image: string,
  buttonTitle: string,
  linkUrl: string,
}

export default (props: PropTypes) => {
  const imageUrl = imageURLWithTransform(props.image, {
    width: 670,
    height: 400,
    crop: 'fill',
  })
  return (
    <li className="biglist__item">
      <p className="biglist__img">
        <a href={props.linkUrl}>
          <OptimizedImage src={imageUrl} alt={props.title} />
        </a>
      </p>
      <div className="biglist__detail">
        <p className="biglist__ttl">{props.title}</p>
        <p className="biglist__text">{props.content}</p>
        <p>
          <a href={props.linkUrl} className="btn__small btn__style bg_blue">
            {props.buttonTitle}
          </a>
        </p>
      </div>
    </li>
  )
}



// WEBPACK FOOTER //
// ./src/components/molecules/TopicContentItem/OneColumn/index.jsx